import { DatapointStatus, PerformanceDatapoint } from "owa-analytics";
import { query } from "owa-apollo";
import { getBootCustomData } from "owa-performance";
import { getAccountScopeUserSettings } from "owa-session-store";
import { PlacesSettingsDocument, type PlacesSettingsQuery, } from "./__generated__/queryPlacesSettings.interface";

import type { MailboxInfo } from "owa-client-types";
import type { ResolverContext } from "owa-graph-schema";
import type { ApolloQueryResult } from "@apollo/client";

export default async function queryPlacesSettings(mailboxInfo: MailboxInfo, names: string[], shouldUseMainThread?: boolean, timeoutMS?: number, noBatching?: boolean, queryDeduplication?: boolean): Promise<ApolloQueryResult<PlacesSettingsQuery | undefined> | {
    data: undefined;
    error: any;
}> {
    // In contrast to the "FETCH_PLACES_SETTINGS" event,
    // "QUERY_PLACES_SETTINGS" only counts the elapsed time for a single request.
    const datapoint = new PerformanceDatapoint("QUERY_PLACES_SETTINGS", mailboxInfo);
    datapoint.addCustomData({ shouldUseMainThread, timeoutMS, noBatching, queryDeduplication });
    datapoint.addCustomData({ hostSessionId: getBootCustomData().HostSessionId }); // Include the MetaOS context for better telemetry
    
    try {
        const userSettings = getAccountScopeUserSettings(mailboxInfo);
        const result = await query(PlacesSettingsDocument, {
            variables: {
                mailboxId: `${userSettings?.SessionSettings?.ExternalDirectoryUserGuid}@${userSettings?.SessionSettings?.ExternalDirectoryTenantGuid}`,
                names,
            },
            context: {
                noBatching,
                requestOptions: {
                    mailboxInfo,
                    timeoutMS,
                },
                gatewayGraphRequest: !!shouldUseMainThread, // When true, send graphql request via main thread.
                queryDeduplication, // When false, allow multiple same queries to be sent to the server.
            } satisfies Partial<ResolverContext>,
        });
        datapoint.end();
        return result;
    }
    catch (error) {
        // Errors resulting from enabling useUnknownInCatchVariables
        // TS2345: Argument of type 'unknown' is not assignable to parameter of type 'TraceErrorObject | ErrorCodes'.
        // @ts-expect-error
        datapoint.endWithError(DatapointStatus.ServerError, error);
        return { data: undefined, error };
    }
}
